"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInvoiceRecipient = void 0;
const typeorm_1 = require("typeorm/browser");
let AccountInvoiceRecipient = class AccountInvoiceRecipient {
};
__decorate([
    (0, typeorm_1.ViewColumn)(),
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], AccountInvoiceRecipient.prototype, "account_potential_invoice_receipients", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)(),
    __metadata("design:type", String)
], AccountInvoiceRecipient.prototype, "sfid", void 0);
AccountInvoiceRecipient = __decorate([
    (0, typeorm_1.ViewEntity)({
        name: 'account_invoice_receipient',
        schema: 'analytics',
        expression: `
    SELECT unnest(array[id, parentid, invoicerecipient__c]) AS account_potential_invoice_receipients,
           id AS sfid
    FROM public.account
  `,
    })
], AccountInvoiceRecipient);
exports.AccountInvoiceRecipient = AccountInvoiceRecipient;
//# sourceMappingURL=account-invoice-recipient.js.map